import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, keyframes } from '@mui/system';
import * as COLORS from '../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersSkeleton';
var rotate = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    width: 0;\n  }\n\n  to {\n    wdith: 100%;\n  }\n"])));
export var createSkeletonTheme = function createSkeletonTheme(theme) {
  return createTheme(_objectSpread(_objectSpread({}, theme || {}), {}, {
    components: {
      MuiSkeleton: {
        styleOverrides: {
          root: _defineProperty({
            background: COLORS.PROMETHEAN_NEUTRAL_MID_GREY
          }, "&.".concat(ROOT_PREFIX, "-animation-progress"), {
            animation: "".concat(rotate, " 2s linear infinite")
          })
        }
      }
    }
  }));
};